import { render, staticRenderFns } from "./MusicPlayer.vue?vue&type=template&id=2ed97cac&scoped=true"
import script from "./MusicPlayer.vue?vue&type=script&lang=js"
export * from "./MusicPlayer.vue?vue&type=script&lang=js"
import style0 from "./MusicPlayer.vue?vue&type=style&index=0&id=2ed97cac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed97cac",
  null
  
)

export default component.exports